import React, { useState } from 'react'
import serviceNow from "./../../assets/serviceNow.png"
import { useTranslation } from 'react-i18next';
import { useClickAway } from '@uidotdev/usehooks';

const ServiceNow = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false)
    const ref: any = useClickAway(() => { setOpen(false); });

    return (
        <div className="relative group" onClick={() => setOpen(!open)}>
            <div className="w-[54px]">
                <div className={`h-[50px] w-full flex justify-center cursor-pointer items-center hover:bg-[#1b191933]`}>
                    <span className="bg-bdo-primary-red"></span>
                    <figure><img src={serviceNow} alt="" width={40} /></figure>
                </div>
            </div>
            {
                open &&
                <ul className="bg-[#363636] w-[290px] absolute flex-col flex -top-[108px] left-[55px] transition-opacity duration-300" ref={ref}>
                    <li className="text-white p-4 pb-2">AssistMe</li>
                    <li><hr className="bg-bdo-primary-red w-[90px] border-none h-[5px] text-sm" /></li>
                        <a href="https://bdocanprod.service-now.com/insighthub" target="_blank" className="text-white hover:bg-[#0f0e0e33] p-4 cursor-pointer text-sm">{t("createSupportTicket")}</a>
                    <a href="https://bdocanprod.service-now.com/ess?id=my_requests" target="_blank" className="text-white hover:bg-[#0f0e0e33] p-4 cursor-pointer text-sm">{t("myServiceNowTickets")}</a>
                </ul>}
        </div>
    )
}
export default ServiceNow